import { render, staticRenderFns } from "./SfCarousel.vue?vue&type=template&id=b26d308c&"
import script from "./SfCarousel.vue?vue&type=script&lang=js&"
export * from "./SfCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SfCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports